export const DATE_TIME_LOCALE = navigator.language;
